import React from 'react'
import StyledAdminWrapper from './StyledAdminWrapper'

const BatchedFlowControl = React.lazy(() => import(/* webpackChunkName: 'admin-bfc-builder' */'components_v2/Admin/BatchedFlowControl'))

const StyledBatchedFlowControl = ({ ...rest }) => {
  return (
    <StyledAdminWrapper>
      <BatchedFlowControl {...rest} />
    </StyledAdminWrapper>
  )
}

export default StyledBatchedFlowControl
